'use strict'

import {
  Polymer
} from '@polymer/polymer/lib/legacy/polymer-fn.js'
import {
  dom,
  flush
} from '@polymer/polymer/lib/legacy/polymer.dom.js'
import {
  html
} from '@polymer/polymer/lib/utils/html-tag.js'
import '@polymer/iron-collapse/iron-collapse'
Polymer({
  is: 'moskito-rating',
  _template: html`
<style include="iron-flex iron-flex-alignment">
  :host {
    --moskito-rating-icon-width: 24px;
    --moskito-rating-color: var(--default-primary-color);
  }
  iron-icon {
    --iron-icon-width: var(--moskito-rating-icon-width);
    --iron-icon-fill-color: var(--moskito-rating-color);
  }
</style>
<div class="horizontal layout" id="star-container">
<dom-repeat items="[[stars]]">
<template is="dom-repeat">
  <iron-icon icon="[[item.value]]"></iron-icon>
</template>
<dom-repeat>
</div>
`,
  properties: {
    rating: { type: String },
    scale: { type: String, value: 5 },
    stars: {
      type: Array,
      computed: 'generateStars(rating, scale)'
    }
  },
  generateStars: function (rating, scale) {
    let value = rating * scale
    let stars = []
    for (let i = 0; i < this.scale; i++) {
      let icon = "icons:star-border"
      if ( value > i+0.5 ) {
        icon = "icons:star"
      }
      if ( value > i && value <= i+0.5 ) {
        icon = "icons:star-half"
      }
      stars[i] = {'value': icon}
    }
    return stars
  }
})
